import * as ReactService from "@intech/react-service";
import { FichaContribPrevidencialEntidade, SaldoAcumuladoEntidade } from "@entidades";

class FichaContribPrevidencial extends ReactService.BaseService {
  constructor() {
    super("FichaContribPrevidencial");
  }

  BuscarSaldos = (sqPlano: number) =>
    this.CreateRequest<SaldoAcumuladoEntidade>(ReactService.RequestType.GET, `BuscarSaldos/${sqPlano}`);

  BuscarQuotas = (sqPlano: number) =>
    this.CreateRequest<any[]>(ReactService.RequestType.GET, `BuscarQuotas/${sqPlano}`);

  BuscarUltimaReferenciaPorPlano = (sqPlano: number) =>
    this.CreateRequest<FichaContribPrevidencialEntidade>(ReactService.RequestType.GET, `BuscarUltimaReferenciaPorPlano/${sqPlano}`);

  BuscarUltimaContribuicao = (sqPlanoPrevidencial: number) =>
    this.CreateRequest<Array<FichaContribPrevidencialEntidade>>(ReactService.RequestType.GET, `BuscarUltimaContribuicao/${sqPlanoPrevidencial}`);
}

export const FichaContribPrevidencialService = new FichaContribPrevidencial();
